import React, { useEffect, useState, useContext } from "react";
import "./SideCoverNavbar.scss";

function SideCoverNavbar({
  showMediumDesignbar,
  setShowMediumDesignbar,
  children,
}) {
  return (
    <div
      id="sidebarCover"
      className="sidebarCover"
      style={{ width: showMediumDesignbar ? "300px" : "0" }}
    >
      <div>
        <span
          className="tempclosebtn"
          onClick={() => setShowMediumDesignbar(false)}
        >
          ×
        </span>
        <div className="row m-0 cover_navbar_lists">{children}</div>
      </div>
    </div>
  );
}

export default SideCoverNavbar;
